module.exports = __webpack_public_path__ + "static/media/122.7780dc20.png";